import type { FetchFunction } from '#layers/base/public';
import type { MonospaceWorkspaceMember } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import { deleteMembers } from '~/rstore/utils/collections/members';
import { defineSystemDateTimeFields, defineSystemDateTimeFieldTypes } from '~/rstore/utils/system-datetime-fields';

const MEMBER_DATETIME_FIELDS = ['lastActivityAt'] as const;

export function createWorkspaceMember(workspaceFetch: FetchFunction) {
	return withItemType<MonospaceWorkspaceMember>().defineCollection({
		name: 'MonospaceSystemUser',
		fields: defineSystemDateTimeFields(MEMBER_DATETIME_FIELDS),
		meta: {
			defaultFields: ['id', 'email', 'fullName', 'isService', 'status', 'lastActivityAt'],
			// Deletion goes through the `delete`/`deleteMany` hooks below.
			endpoint: 'members',
			primitiveFieldTypes: defineSystemDateTimeFieldTypes(MEMBER_DATETIME_FIELDS),
		},
		hooks: {
			async delete({ key }) {
				await deleteMembers({ ids: [key as string], workspaceFetch });
			},
			async deleteMany({ keys }) {
				await deleteMembers({ ids: keys as string[], workspaceFetch });
			},
		},
	});
}
